import { faker } from '@faker-js/faker'

import { PartnerHospitalView } from '../../contracts/hospital'
import { TargetLanguage } from '../../contracts/service-offer'
import { asBuilder } from '../asBuilder'

export const getPartnerHospitalView = asBuilder((): PartnerHospitalView => {
  return {
    hospitalId: faker.number.int(),
    consultation: {
      consultableLanguages: faker.helpers.uniqueArray(Object.values(TargetLanguage), 2),
    },
  }
})
